import template from './security.html';
import * as api from '../../resources/security.api';

const mapStateToThis = ({ session, config }) => {
  const { locale } = session;
  const passwordErrorText = config.passwordErrorText[locale];

  return {
    locale,
    passwordErrorText,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class SecurityController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.securityQuestions = await api.fetchSecurityQuestions();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  shouldShowValidation(field) {
    return ((field.$$parentForm.$submitted || field.$submitted) && field.$pristine) || field.$touched;
  }

  showPasswordConfirmRequired($formCtrl) {
    return this.shouldShowValidation($formCtrl.userPasswordConfirm) && $formCtrl.userPassword.$valid && $formCtrl.userPassword.$touched;
  }

  // show password match validation only if no other validators are present
  showPasswordsMatchError($formCtrl) {
    return (
      this.shouldShowValidation($formCtrl.userPasswordConfirm) &&
      !$formCtrl.userPasswordConfirm.$error.required &&
      $formCtrl.userPassword.$valid &&
      $formCtrl.userPassword.$touched
    );
  }
}

export default class SecurityComponent {
  constructor() {
    this.template = template;
    this.controller = SecurityController;
    this.bindings = {
      form: '<',
      formModel: '=',
      captchaVisible: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/security/components/security/security-component.js